const BaseModel = require('./BaseModel');
const HTTPClient = require('../HTTPClient');

class Company extends BaseModel {
  static basePath = '/api/v1/companies';
  static dataType = 'company';

  static brandingsBasePath = `${this.basePath}/:companyId/brandings`
  static entityVisibilitiesBasePath = `${this.basePath}/:companyId/entities`

  brandingsBasePath = () => this.constructor.brandingsBasePath.replace(':companyId', this.id);
  entityVisibilitiesBasePath = () => this.constructor.entityVisibilitiesBasePath.replace(':companyId', this.id);

  constructor(json={}) {
    super(json);

    this.brandingsBasePath = this.brandingsBasePath.bind(this);
    this.entityVisibilitiesBasePath = this.entityVisibilitiesBasePath.bind(this);
    this.listBrandings = this.listBrandings.bind(this);
    this.createBranding = this.createBranding.bind(this);
    this.getBrandingById = this.getBrandingById.bind(this);
    this.updateBranding = this.updateBranding.bind(this);
    this.deleteBranding = this.deleteBranding.bind(this);

    this.listVisibleEntities = this.listVisibleEntities.bind(this);
    this.createEntityVisibility = this.createEntityVisibility.bind(this);
    this.deleteEntityVisibility = this.deleteEntityVisibility.bind(this);
  }


  listBrandings(args) {
    return(BaseModel.list({ ...args, path: this.brandingsBasePath() }));
  }

  createBranding(item, { include = null } = {}) {
    return(BaseModel.create(item, { include: include, path: this.brandingsBasePath() }));
  }

  getBrandingById(id, { include = null } = {}) {
    return(BaseModel.getById(id, { include: include, path: this.brandingsBasePath() }));
  }

  updateBranding(item, { include = null, path = null } = {}) {
    return(BaseModel.update(item, { include: include, path: this.brandingsBasePath() }));
  }

  deleteBranding(item) {
    return(BaseModel.delete(item, { path: this.brandingsBasePath() }));
  }

  listVisibleEntities(args) {
    return(BaseModel.list({ ...args, path: this.entityVisibilitiesBasePath() }));
  }

  createEntityVisibility(entity) {
    BaseModel.create(entity, { path: `${this.entityVisibilitiesBasePath()}/${entity.id}` })
  }

  deleteEntityVisibility(entity) {
    BaseModel.delete(entity, { path: this.entityVisibilitiesBasePath() })
  }
}

BaseModel.models[Company.dataType] = Company;
module.exports = Company;
